import React, {useMemo} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { Image, JerseyModeEnum } from "../../../client/api";
import ClavaImage from "../ClavaImage";
import Jersey from "../Jersey";

interface PlayerImageProps {
  image?: Image | null;
  width: number;
  className?: string;
  alt?: string;
  rounded?: boolean;
  round?: boolean;
  jerseyColor1?: string;
  jerseyColor2?: string;
  jerseyMode?: JerseyModeEnum;
}

const PlayerImage: React.FC<PlayerImageProps> = ({ 
  image, 
  width, 
  className, 
  alt, 
  rounded, 
  round, 
  jerseyColor1, 
  jerseyColor2, 
  jerseyMode
}) => {
  const chosen = useMemo(() => image ?? null, [image]);

  const borderRadiusStyle = useMemo(() => {
    if (round || className?.includes("rounded-full")) {
      return { borderRadius: 1000 };
    }
    if (rounded) {
      return { borderRadius: 8 };
    }
    return {};
  }, [round, rounded, className]);

  if (!chosen) {
    if (jerseyColor1 && jerseyMode && jerseyColor1.trim() !== '') {
      const color1 = jerseyColor1.trim();
      const color2 = jerseyColor2 && jerseyColor2.trim() !== '' ? jerseyColor2.trim() : color1;
      
      return (
        <div style={{ width, height: width, ...borderRadiusStyle, overflow: 'hidden' }}>
          <Jersey
            color1={color1}
            color2={color2}
            mode={jerseyMode}
            size={width}
            className="w-full h-full"
          />
        </div>
      );
    }
    
    return (
      <div 
        className={`bg-bg-100 dark:bg-bg-100-dark flex items-center justify-center ${className ?? ""}`}
        style={{ 
          width, 
          height: width,
          ...borderRadiusStyle,
          overflow: 'hidden',
        }}
      >
        <FontAwesomeIcon 
          icon={faUser} 
          className="text-font-600 dark:text-font-600-dark"
          style={{ 
            width: width * 0.5, 
            height: width * 0.5 
          }}
        />
      </div>
    );
  }

  return (
    <ClavaImage
      image={chosen}
      width={width}
      className={className}
      alt={alt}
      forceAspectRatio={round || className?.includes("rounded-full") ? 1 : undefined}
      rounded={rounded}
      round={round}
    />
  );
};

export default PlayerImage;




